/**
 * Excludes high-frequency, CD-irrelevant DOM events from zone.js patching.
 *
 * Without this, EVERY mouseenter/mouseleave/mousemove/scroll anywhere on the page (including
 * inside the zsui <zs-tooltip> custom element, used hundreds of times per financial table, and
 * the app's many `(mouseenter)="x.classList.add(...)"` inline-tooltip bindings) schedules a
 * full-app change-detection tick via zone.js, even though none of these events touch any
 * Angular-bound state (they're all plain DOM classList/scroll property manipulation). This was
 * confirmed the dominant cause of hover/scroll lag in profiling (refreshView/isLContainer
 * dominating self time on a simple mouseover).
 *
 * Must be imported in polyfills.ts BEFORE `import 'zone.js'` — these flags only take effect if
 * set on window before zone.js patches addEventListener.
 */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'mouseover', 'mouseenter', 'mouseleave'];
